import { render, staticRenderFns } from "./LibraryDetail.vue?vue&type=template&id=97941596&scoped=true&"
import script from "./LibraryDetail.vue?vue&type=script&lang=js&"
export * from "./LibraryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97941596",
  null
  
)

export default component.exports